import type { Sequence } from "@pdfking/tfunc"

import { ContentType } from "../types/files/ContentType"

export function PathContentType(
  names: Sequence<string>
): ContentType | undefined {
  for (const s of names) {
    const lower = s.toLowerCase()
    if (lower.endsWith(".jpeg") || lower.endsWith(".jpg"))
      return ContentType.JPEG
    if (lower.endsWith(".pdf")) return ContentType.PDF
    if (lower.endsWith(".png")) return ContentType.PNG
    if (lower.endsWith(".zip")) return ContentType.ZIP
  }
  return undefined
}
